import { Editor } from "@tiptap/core";
import type { JSONContent } from "@tiptap/react";

import { parseMarkdownToHtml } from "../editor/parse-markdown-to-slice";
import { getSkillCollectionMarkdownBaseExtensions } from "../editor/skill-markdown-extensions";

import { joinSkillMarkdown, splitSkillMarkdown } from "./skill-frontmatter";

const withConversionEditor = <T>(getResult: (editor: Editor) => T): T => {
  const editor = new Editor({
    element: null,
    extensions: getSkillCollectionMarkdownBaseExtensions(),
    content: "",
  });

  try {
    return getResult(editor);
  } finally {
    editor.destroy();
  }
};

export const markdownBodyToJson = (markdown: string): JSONContent => {
  if (!markdown.trim()) {
    return { type: "doc", content: [] };
  }

  return withConversionEditor(editor => {
    editor.commands.setContent(parseMarkdownToHtml(markdown), {
      emitUpdate: false,
    });

    return editor.getJSON();
  });
};

export const jsonToMarkdownBody = (json: JSONContent): string =>
  withConversionEditor(editor => {
    editor.commands.setContent(json, { emitUpdate: false });
    return editor.getMarkdown().trimEnd();
  });
export interface SkillDocumentJson {
  frontmatter: string | null;
  bodyJson: JSONContent;
}

export const markdownToDocumentJson = (markdown: string): SkillDocumentJson => {
  const parsedDocument = splitSkillMarkdown(markdown);
  return {
    frontmatter: parsedDocument.frontmatter,
    bodyJson: markdownBodyToJson(parsedDocument.body),
  };
};

export const documentJsonToMarkdown = (doc: SkillDocumentJson): string =>
  joinSkillMarkdown(doc.frontmatter, jsonToMarkdownBody(doc.bodyJson));
